import type SplitIO from '@splitsoftware/splitio/types/splitio';

export type BrowserSplitClient = SplitIO.IClient | SplitIO.IAsyncClient;

/**
 * Get local GraphQL resolvers for accessing Split.io treatments.
 *
 * Right now, these are only used to pass the initial Split.io treatment from
 * the server to the client to support Split.io with SSR. In that case, these
 * resolvers won't run and the server treatment will be returned from Apollo
 * Client's cache. Otherwise, return `undefined` to preserve the existing
 * client-side behavior for the initial value.
 *
 * @see {@link ../server/routers/ssr/graphql/split.ts}
 *
 * @returns local resolver mapping to be passed to `resolvers` option of
 * `ApolloClient` constructor
 */
export const getSplitClientResolvers = () => ({
  Query: {
    getTreatment: () => undefined,
    getTreatmentWithConfig: () => undefined,
  },
});
